module.exports = __webpack_public_path__ + "static/media/chess-queen-alt.741f7422.svg";